/* GSW_FOMO_NAV_SYNC_START */
(function(){
  function syncFomoToMobileNav(){
    var nav=document.querySelector('.gsw-bnav');
    if(!nav)return;
    document.documentElement.style.setProperty(
      '--gsw-fomo-nav-height',
      nav.getBoundingClientRect().height.toFixed(2)+'px'
    );
  }
  syncFomoToMobileNav();
  window.addEventListener('resize',syncFomoToMobileNav,{passive:true});
  if(window.ResizeObserver){
    var gswFomoNavObserver=new ResizeObserver(syncFomoToMobileNav);
    var gswFomoNav=document.querySelector('.gsw-bnav');
    if(gswFomoNav)gswFomoNavObserver.observe(gswFomoNav);
  }
})();
/* GSW_FOMO_NAV_SYNC_END */

function gswDrawer(open){gswCollections(false);document.getElementById('gswDrawer').classList.toggle('open',open);document.body.style.overflow=open?'hidden':'';}
function gswCollections(force){
  var menu=document.getElementById('gswCollectionsMenu'),btn=document.getElementById('gswCollectionsToggle');
  if(!menu||!btn)return;
  var open=typeof force==='boolean'?force:!menu.classList.contains('open');
  menu.classList.toggle('open',open);
  btn.setAttribute('aria-expanded',open?'true':'false');
}
document.addEventListener('click',function(e){
  var menu=document.getElementById('gswCollectionsMenu'),btn=document.getElementById('gswCollectionsToggle');
  if(menu&&menu.classList.contains('open')&&!menu.contains(e.target)&&!btn.contains(e.target))gswCollections(false);
});
document.addEventListener('keydown',function(e){if(e.key==='Escape')gswCollections(false);});

(function(){var on=document.querySelector('.gsw-chip.on');if(on&&on.parentNode){on.parentNode.scrollLeft=Math.max(0,on.offsetLeft-70);}})();

var GSW_CAT=null,GSW_CAT_P=null,GSW_T=null,GSW_LAST='';
function gswSearchOpen(open){
  var el=document.getElementById('gswSearch');
  el.classList.toggle('open',open);
  document.body.style.overflow=open?'hidden':'';
  if(open){setTimeout(function(){document.getElementById('gswSearchInput').focus();},280);}
}
function gswLoadCat(){
  if(GSW_CAT!==null)return Promise.resolve(GSW_CAT);
  if(GSW_CAT_P)return GSW_CAT_P;
  GSW_CAT_P=fetch('/products.json?limit=250').then(function(r){return r.json();}).then(function(d){
    GSW_CAT=(d.products||[]).map(function(p){
      var v=(p.variants&&p.variants[0])||{},im=(p.images&&p.images[0])||{};
      return{t:p.title,h:'/products/'+p.handle,img:im.src||'',pr:v.price||'',tags:(p.tags||[]).join(' '),ty:p.product_type||''};
    });
    return GSW_CAT;
  }).catch(function(){GSW_CAT=[];return GSW_CAT;});
  return GSW_CAT_P;
}
function gswLev(a,b){
  var m=a.length,n=b.length;if(!m)return n;if(!n)return m;
  var prev=[],cur=[],i,j;
  for(j=0;j<=n;j++)prev[j]=j;
  for(i=1;i<=m;i++){cur[0]=i;
    for(j=1;j<=n;j++){cur[j]=Math.min(prev[j]+1,cur[j-1]+1,prev[j-1]+(a.charAt(i-1)===b.charAt(j-1)?0:1));}
    for(j=0;j<=n;j++)prev[j]=cur[j];
  }
  return prev[n];
}
function gswScore(q,txt){
  q=q.toLowerCase();txt=(txt||'').toLowerCase();
  if(txt.indexOf(q)>-1)return 0;
  var w=txt.split(/[^a-z0-9]+/),best=9,i,d,n;
  for(i=0;i<w.length;i++){
    if(!w[i])continue;
    var c=w[i].slice(0,Math.max(q.length+2,3));
    d=gswLev(q,c);n=d/Math.max(q.length,c.length,1);
    if(n<best)best=n;
  }
  return best;
}
function gswEsc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function gswCard(p){
  return '<a class="gsw-sitem" href="'+p.h+'">'+(p.img?'<img src="'+p.img+'" alt="" width="46" height="58" loading="lazy" decoding="async">':'<img alt="" width="46" height="58">')+'<div><div class="t">'+gswEsc(p.t)+'</div>'+(p.pr?'<div class="p">&#8377;'+gswEsc(p.pr)+'</div>':'')+'</div></a>';
}
function gswRender(q){
  var box=document.getElementById('gswSearchRes');
  if(q!==document.getElementById('gswSearchInput').value.trim())return;
  if(!q||q.length<2){box.innerHTML='<div class="gsw-schips"><a href="/collections/t-shirts">Oversized Tees</a><a href="/collections/hoodies">Hoodies</a><a href="/collections/anime-collection-1">Anime</a><a href="/collections/football-collection">Football</a><a href="/collections/flat-499">Deal of the Year</a></div>';return;}
  fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8')
  .then(function(r){return r.json();})
  .then(function(d){
    if(q!==document.getElementById('gswSearchInput').value.trim())return;
    var ps=((d.resources||{}).results||{}).products||[];
    if(ps.length){
      box.innerHTML=ps.map(function(p){return gswCard({t:p.title,h:p.url,img:(p.image||''),pr:''});}).join('')
        +'<a class="gsw-sterm" href="/search?type=product&q='+encodeURIComponent(q)+'">See all results for <span>'+gswEsc(q)+'</span></a>';
    }else{gswFuzzy(q,box);}
  }).catch(function(){gswFuzzy(q,box);});
}
function gswFuzzy(q,box){
  if(q!==document.getElementById('gswSearchInput').value.trim())return;
  if(GSW_CAT===null){
    box.innerHTML='<div class="gsw-sempty">Checking similar products...</div>';
    gswLoadCat().then(function(){gswFuzzy(q,box);});
    return;
  }
  if(!GSW_CAT.length){box.innerHTML='<div class="gsw-sempty">No matches for \u201c'+gswEsc(q)+'\u201d</div>';return;}
  var out=[],i,s;
  for(i=0;i<GSW_CAT.length;i++){
    s=Math.min(gswScore(q,GSW_CAT[i].t),gswScore(q,GSW_CAT[i].ty),gswScore(q,GSW_CAT[i].tags));
    if(s<=0.45)out.push({p:GSW_CAT[i],s:s});
  }
  out.sort(function(a,b){return a.s-b.s;});
  if(!out.length){box.innerHTML='<div class="gsw-sempty">Nothing matched \u201c'+gswEsc(q)+'\u201d. Try tshirt, hoodie, anime or shorts.</div>';return;}
  box.innerHTML='<div class="gsw-shint">No exact match &mdash; did you mean <b>'+gswEsc(out[0].p.t)+'</b>?</div>'
    +out.slice(0,8).map(function(o){return gswCard(o.p);}).join('');
}
(function(){
  var inp=document.getElementById('gswSearchInput');
  if(!inp)return;
  inp.addEventListener('input',function(){
    var v=inp.value.trim();
    if(v===GSW_LAST)return;GSW_LAST=v;
    clearTimeout(GSW_T);GSW_T=setTimeout(function(){gswRender(v);},190);
  });
  inp.addEventListener('keydown',function(e){
    if(e.key==='Enter'&&inp.value.trim()){window.location='/search?type=product&q='+encodeURIComponent(inp.value.trim());}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')gswSearchOpen(false);});
})();
